import React from 'react'
import './Input.styl'

const Input = ({ inputClasses, ...rest }) => {
  return <input {...rest} className={`${inputClasses && inputClasses.join(' ')} input`} />
}

export default Input
